export var blur = function (el) {
    el === null || el === void 0 ? void 0 : el.blur();
};
